const userGuideEn = {
    documents: require('../../lang/en/user_guide/Documents').default,
};

export default userGuideEn;
